import "./styles.scss";

import React, { useState } from "react";

import { PageTitle } from "../../components/PageTitle";
import { useOrganizationContext } from "../../contexts/organizations/organizationsContext";
import { useApplications } from "../../hooks/reactQueryHooks/useApplications";
import { formatNumber } from "../../utils/NumbersFormatting";
import { AddCacheItem } from "./components/AddCacheItem/AddCacheItem";
import { ExportCacheItem } from "./components/AddCacheItem/ExportCacheItem";
import { CachePage } from "./components/CachePage/CachePage";

const settingsBreadcrumbs = [
  {
    title: "Safety & Compliance",
    path: "",
    isSeparator: false,
    isActive: true,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];

const CacheWrapper = () => {
  const { currentOrganization } = useOrganizationContext();
  const [totalItems, setTotalItems] = useState<number>(0);
  const [showExportComponent, setShowExportComponent] =
    useState<boolean>(false);
  const { data = [] } = useApplications(currentOrganization?.id || "");

  return (
    <>
      <div className="wrapper-header-export-btn-question-history">
        <PageTitle
          breadcrumbs={settingsBreadcrumbs}
          breadcrumbTitle="Cache"
          pageTitle={`Cache items ${
            totalItems ? `(${formatNumber(totalItems)})` : ""
          }`}
        />
        <div className="d-flex align-items-center position-relative w-350px justify-content-sm-end justify-content-start ">
          {showExportComponent && <ExportCacheItem applications={data} />}
          <AddCacheItem applications={data} />
        </div>
      </div>
      {currentOrganization && (
        <CachePage
          currentOrganization={currentOrganization}
          applications={data}
          setTotalItems={setTotalItems}
          setShowExportComponent={setShowExportComponent}
        />
      )}
    </>
  );
};

export { CacheWrapper };
